import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RenterRegFormService } from '@accounts/operator/services/renter-reg-form.service';
import { UserModel } from '@core/api/model/userModel';
import { TransportModel } from '@core/api/model/transportModel';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { of } from 'rxjs/internal/observable/of';
import { RegisteredService } from '@core/auth/services/registered.service';

export interface DialogData {
  user: UserModel;
  transport: TransportModel
}

@Component({
  selector: 'user-modal-personal-data',
  templateUrl: './modal-personal-data.component.html',
  styleUrls: ['./modal-personal-data.component.scss']
})
export class ModalPersonalDataComponent implements OnInit, OnDestroy {

  constructor(
    private renterRegFormService: RenterRegFormService,
    private registeredService: RegisteredService,
    private i18n: I18n,
    public dialogRef: MatDialogRef<ModalPersonalDataComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData)
  {
    this.renterRegFormService.successMessage = this.i18n('Данные успешно сохранены');

    this.renterRegFormService.buildForms({
      renter: this.data.user,
      transport: this.data.transport,
      verification: true
    });
  }

  get loading () {
    return this.renterRegFormService.loading$;
  }

  submit() {
    this.renterRegFormService.requestUpdateUserData(() => {
      this.registeredService.reset();
      this.dialogRef.close(true);
    });
  }

  ngOnDestroy() {
    this.renterRegFormService.reset();
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
  }

}
